export default __webpack_public_path__ + "static/media/MiTradeLogo2.292b4d58.png";